export var MISSING_CATEGORY_AND_ACTION = 'Category and action must be specified';
export var MISSING_CUSTOM_PARAMS = 'Custom parameters must be specified';
export var JSON_INVALID = 'Could not parse JSON';
export var CLIPBOARD_UNSUPPORTED = 'Clipboard is not supported';
export var REQUIRED_ELEMENTS_NOT_FOUND = 'Could not find all required elements';
export var FIELD_HAS_ERRORS = 'message.jsModules.constants.errors.fieldHasErrors';
export var FIELD_IS_REQUIRED = 'message.jsModules.constants.errors.fieldIsRequired';
export var FIELD_DOES_NOT_MATCH = 'message.jsModules.constants.errors.fieldMustMatchAnotherField';
export var COUNTRY_NOT_FOUND = 'message.jsModules.constants.errors.countryNotFound';
